import React from 'react';
import { RefreshCw, Filter, Calendar, ChevronLeft, ChevronRight } from 'lucide-react';
import { format } from 'date-fns';
import './AnalyticsHeader.css';

const AnalyticsHeader = ({ onDateRangeClick, onReset, dateRange, onQuickSelect, onShiftDate, selectedRangeType }) => {
  const rangeText = `${format(dateRange.start, 'MMM dd')} - ${format(dateRange.end, 'MMM dd, yyyy')}`;

  const quickRanges = [
    { label: '7D', value: 7 },
    { label: '14D', value: 14 },
    { label: '30D', value: 30 },
    { label: '90D', value: 90 }
  ];

  return (
    <header className="header">
      <div className="header-left">
        <div className="page-title">
          <RefreshCw className="title-icon animate-spin-slow" size={20} />
          <h1>Analytics</h1>
        </div>
      </div>

      <div className="header-controls">
        <div className="date-control-group">
          <button className="shift-btn" onClick={() => onShiftDate(-1)} aria-label="Previous date range">
            <ChevronLeft size={16} strokeWidth={2} />
          </button>
          
          <button className="control-btn date-btn" onClick={onDateRangeClick}>
            <Calendar size={16} className="text-gray-500" strokeWidth={1.5} />
            <span className="font-medium text-gray-700">{rangeText}</span>
          </button>

          <button className="shift-btn" onClick={() => onShiftDate(1)} aria-label="Next date range">
            <ChevronRight size={16} strokeWidth={2} />
          </button>
        </div>

        <div className="quick-range-group">
          {quickRanges.map(range => (
            <button 
              key={range.value}
              className={`quick-range-btn ${selectedRangeType === range.value ? 'active' : ''}`}
              onClick={() => onQuickSelect(range.value)}
            >
              {range.label}
            </button>
          ))}
        </div>

        <button className="reset-btn" onClick={onReset}>
          Reset
        </button>
      </div>

      <div className="header-actions">
        <div className="flex items-center gap-2 px-3 py-1.5 bg-green-50 border border-green-200 rounded-full">
          <span className="relative flex h-2 w-2">
            <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-green-400 opacity-75"></span>
            <span className="relative inline-flex rounded-full h-2 w-2 bg-green-500"></span>
          </span>
          <span className="text-xs font-semibold text-green-700">Live</span>
        </div>
      </div>
    </header>
  );
};

export default AnalyticsHeader;
